import { type DehydratedState, dehydrate, hydrate } from '@tanstack/react-query';
import type { ApiClient } from '@tunein/web-api-client';
import { createStores, getStoresState, type InitialStoresState } from 'src/common/stores';
import { createQueryClient } from './createQueryClient';
import type { AppServices, AppServicesPayload } from './types';

interface CreateAppServicesOptions {
  api: ApiClient;
  queryState?: DehydratedState;
  storesState?: InitialStoresState;
}

export function createAppServices({
  api,
  queryState,
  storesState,
}: CreateAppServicesOptions): AppServices {
  const queryClient = createQueryClient();

  if (queryState) {
    hydrate(queryClient, queryState);
  }

  return { api, queryClient, stores: createStores(storesState) };
}

export function getAppServicesPayload({ queryClient, stores }: AppServices): AppServicesPayload {
  return {
    queryState: dehydrate(queryClient),
    storesState: getStoresState(stores),
  };
}
